import React, { useEffect, useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// AVISO DE NOVA VERSÃO
//
// [2026-08-12] Em 22/08 o chat com edital ficou dando "Não foi possível obter
// resposta". O servidor respondia certo — status 200 em 29s. O que acontecia é que
// o navegador do Erivan ainda rodava o JavaScript antigo, com 30s de paciência,
// e desistia sozinho (o nginx registrava 499 = cliente fechou a conexão).
//
// Ele ficou horas com a página aberta sem recarregar. Não tinha como saber: nada
// na tela dizia que existia versão nova. Este componente fecha esse buraco.
//
// COMO DESCOBRE
//     O index.html é servido sem cache e aponta para /static/js/main.<hash>.js.
//     A cada build o hash muda. Comparamos o hash que ESTA página carregou com o
//     que o servidor entrega agora. Diferente = tem versão nova esperando.
//
//     Não precisa de arquivo de versão nem de mudança no build: o próprio nome do
//     arquivo já é a versão.
//
// POR QUE NÃO RECARREGA SOZINHO
//     Recarregar no meio de uma pergunta digitada, ou de uma análise rodando, seria
//     pior que o problema. Avisamos e deixamos o clique com ele.
// ─────────────────────────────────────────────────────────────────────────────

const INTERVALO = 90000; // 1min30 — versão nova não aparece de minuto em minuto

function hashCarregado() {
  const marca = /\/static\/js\/main\.[A-Za-z0-9]+\.js/;
  const script = Array.from(document.querySelectorAll('script[src]'))
    .map((s) => s.getAttribute('src') || '')
    .find((src) => marca.test(src));
  const achado = script && script.match(marca);
  return achado ? achado[0] : null;
}

async function hashNoServidor() {
  try {
    const r = await fetch('/index.html', { cache: 'no-store' });
    if (!r.ok) return null;
    const html = await r.text();
    const achado = html.match(/\/static\/js\/main\.[A-Za-z0-9]+\.js/);
    return achado ? achado[0] : null;
  } catch (e) {
    return null; // sem internet ou servidor reiniciando — tenta de novo depois
  }
}

export default function AvisoNovaVersao() {
  const [temNova, setTemNova] = useState(false);

  useEffect(() => {
    const meu = hashCarregado();
    if (!meu) return; // em desenvolvimento não existe main.<hash>.js

    let vivo = true;
    const conferir = async () => {
      const doServidor = await hashNoServidor();
      if (vivo && doServidor && doServidor !== meu) setTemNova(true);
    };

    conferir();
    const t = setInterval(conferir, INTERVALO);
    // confere também quando ele volta pra aba — é quando costuma retomar o trabalho
    const aoVoltar = () => { if (!document.hidden) conferir(); };
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      vivo = false;
      clearInterval(t);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, []);

  if (!temNova) return null;

  return (
    <div className="nv-barra" role="status">
      <span className="nv-texto">
        <strong>Nova versão disponível.</strong>{' '}
        Recarregue para evitar erros — a página aberta ainda usa a versão antiga.
      </span>
      <button className="nv-btn" onClick={() => window.location.reload()}>
        Atualizar agora
      </button>
      <style>{`
        .nv-barra {
          position: fixed; left: 50%; transform: translateX(-50%); bottom: 22px;
          z-index: 9999; display: flex; align-items: center; gap: 14px;
          background: #0f172a; color: #fff; padding: 13px 18px;
          border-radius: 11px; box-shadow: 0 8px 26px rgba(15,23,42,.32);
          font-size: .89rem; max-width: min(92vw, 620px);
        }
        .nv-texto { line-height: 1.45; }
        .nv-btn {
          flex: none; padding: 8px 15px; border: none; border-radius: 7px;
          background: #22c55e; color: #06281a; font-weight: 700;
          font-size: .85rem; cursor: pointer; white-space: nowrap;
        }
        .nv-btn:hover { background: #16a34a; color: #fff; }
        @media (max-width: 560px) {
          .nv-barra { flex-direction: column; align-items: stretch; text-align: center; }
        }
      `}</style>
    </div>
  );
}
